module.exports = __webpack_public_path__ + "img/8.a1b4ef23.png";